import {
  ACTIVE,
  MY_RECENT,
  USER_FAVORITED,
  ARCHIVED,
} from 'constants/feedListingTypes';

const getPathForFeedType = (feedType) => {
  switch (feedType) {
    case MY_RECENT:
      return 'viewer.recentProjects';
    case USER_FAVORITED:
      return 'viewer.favoritedProjects';
    case ARCHIVED:
      return 'viewer.company.archivedProjects';
    case ACTIVE:
      return 'viewer.company.activeProjects';
    default:
      return 'viewer.company.recentProjects';
  }
};

export default getPathForFeedType;
